"use strict"; // Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

exports.__esModule = true;
exports.SDK_VERSION = exports.wait = exports.FRAME_TIMEOUT = exports.isMessageEvent = exports.isPostMessageEvent = exports.getUrlInfo = exports.buildExperienceUrl = void 0;

var punycode_1 = require("punycode");

var SDK_VERSION = '2.2.1';
exports.SDK_VERSION = SDK_VERSION;
var FRAME_TIMEOUT = 60000;
exports.FRAME_TIMEOUT = FRAME_TIMEOUT;

var isMessageEvent = function isMessageEvent(messageEvent) {
  return !!messageEvent && !!messageEvent.eventTarget && !!messageEvent.eventName;
};

exports.isMessageEvent = isMessageEvent;

var isPostMessageEvent = function isPostMessageEvent(messageEvent) {
  return !!messageEvent && !!messageEvent.eventId && !!messageEvent.eventTarget && !!messageEvent.eventName;
};

exports.isPostMessageEvent = isPostMessageEvent;

var getUrlInfo = function getUrlInfo(url) {
  var matches = /^(https:\/\/[^/]+)\/(embedding|embed)\/([^/]+)\/[^?]+\?(.*)/i.exec(url) || [];

  if ((matches === null || matches === void 0 ? void 0 : matches.length) < 4) {
    throw "Invalid embedding url: \"".concat(url, "\"");
  }

  var urlInfo = {
    guid: matches[3],
    host: matches[1],
    urlSearchParams: new URLSearchParams(matches[4])
  };
  return urlInfo;
};

exports.getUrlInfo = getUrlInfo;

var buildQueryString = function buildQueryString(options) {
  if (!options || _typeof(options) !== 'object') {
    return '';
  }

  var filteredOptions = Object.entries(options).reduce(function (newOptions, _a) {
    var key = _a[0],
        value = _a[1];

    if (value !== undefined && value !== null) {
      newOptions[key] = "".concat(value);
    }

    return newOptions;
  }, {
    punyCodeEmbedOrigin: (0, punycode_1.encode)("".concat(window.location.origin, "/"))
  });
  return new URLSearchParams(filteredOptions).toString();
};

var buildParametersString = function buildParametersString(parameters) {
  if (!parameters || _typeof(parameters) !== 'object') {
    return '';
  }

  var processedParameters = Object.entries(parameters).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    var values = [].concat(value);
    var encodedName = encodeURIComponent(key);
    return values.map(function (paramValue) {
      return encodeURIComponent(paramValue);
    }).map(function (encodedValue) {
      return "p.".concat(encodedName, "=").concat(encodedValue);
    }).join('&');
  });
  return processedParameters.join('&');
};

var buildExperienceUrl = function buildExperienceUrl(baseUrl, options, internalExperience) {
  if (options === void 0) {
    options = {};
  }

  var parameters = options.parameters,
      otherOptions = __rest(options, ["parameters"]);

  var contextId = internalExperience.contextId,
      discriminator = internalExperience.discriminator;
  var fullQueryStringArray = [];
  var queryString = buildQueryString(__assign(__assign({}, otherOptions), {
    contextId: contextId,
    discriminator: discriminator,
    clientTime: Date.now(),
    sdkVersion: SDK_VERSION
  }));

  if (queryString) {
    fullQueryStringArray.push(queryString);
  }

  var parametersString = buildParametersString(parameters);

  if (parametersString) {
    fullQueryStringArray.push(parametersString);
  }

  var fullQueryString = fullQueryStringArray.join('#');
  var baseUrlString = typeof baseUrl === 'string' ? baseUrl : baseUrl.toString();
  return [baseUrlString, fullQueryString].join(baseUrlString.includes('?') ? '&' : '?');
};

exports.buildExperienceUrl = buildExperienceUrl;

var wait = function wait(delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, delay);
      })];
    });
  });
};

exports.wait = wait;